import React from 'react'
import api from '../../source/api'
import BaseComponent from '../base'
import Field from "../common/Field";
import Validator from "../common/Validator";
import NotificationSystem from 'react-notification-system'

class Onlineszamla extends BaseComponent {

    constructor(props) {
        super(props)
        this._notificationSystem = null;
        this.state = {
            company: {},
            onlineszamlaToken: {},
            company_id: props.location.match.params.id,
            fields: {
                login: {value: '', error: '', role: {required: true}},
                password: {value: '', error: '', role: {required: true}},
                tax_number: {value: '', error: '', role: {required: true}},
                sign_key: {value: '', error: '', role: {required: true}},
                exchange_key: {value: '', error: '', role: {required: true}},
            },
        };
    }

    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem
        window.scrollTo(0, 0)

        api.get('company/onlineszamla?company_id=' + this.state.company_id)
            .then((response) => {
                let fields = this.state.fields;
                if (response.data.onlineszamlaToken) {
                    fields.login.value = response.data.onlineszamlaToken.login;
                    fields.password.value = response.data.onlineszamlaToken.password;
                    fields.tax_number.value = response.data.onlineszamlaToken.tax_number;
                    fields.sign_key.value = response.data.onlineszamlaToken.sign_key;
                    fields.exchange_key.value = response.data.onlineszamlaToken.exchange_key;
                }
                this.setState({
                    company: response.data.company,
                    onlineszamlaToken: response.data.onlineszamlaToken,
                    fields: fields,
                });
            });
    };

    buildSubmitForm = () => {
        let form = new FormData();
        form.append('login', this.state.fields.login.value);
        form.append('password', this.state.fields.password.value);
        form.append('tax_number', this.state.fields.tax_number.value);
        form.append('sign_key', this.state.fields.sign_key.value);
        form.append('exchange_key', this.state.fields.exchange_key.value);
        return form
    };

    submit = () => {
        let validator = Validator.validate(this.state.fields)
        this.setState({error: validator.error});

        if (this.state.error) {
            this.setState({fields: validator.fields});
        }

        if (!this.state.error) {
            this.setState({processing: true});
            api.post('company/onlineszamla?company_id=' + this.state.company_id, this.buildSubmitForm())
                .then((response) => {
                    this.setState({processing: false});
                    this._addNotification('Sikeres adatkapcsolat az onlineszámlával!', 'success', 10)
                })
                .catch((err) => {
                    this.setState({processing: false});
                    this._addNotification(err.response.data.error.message, 'error', 30)
                });
        }
    };

    setValue = (name, value, error) => {
        let fields = this.state.fields;
        fields[name].value = value;
        fields[name].error = error;
        this.setState({fields: fields});
    };

    _addNotification = (msg, type, time = 10) => {
        this.refs.notificationSystem.addNotification({
            message: msg,
            level: type,
            position: 'tc',
            autoDismiss: time
        });
    };

    render() {
        return (
            <div className='container'>
                <section id='company-onlineszamla'>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <h1 className='text-left'>
                                {this.state.company.name}
                            </h1>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-4'>
                            <h3 className='text-left'>Technikai felhasználó beállítása</h3>
                            <Field
                                type="text"
                                name="login"
                                label="NAV technikai felhasználónév"
                                classLabel="control-label"
                                classInput="form-control"
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                            <Field
                                type="password"
                                name="password"
                                label="Technikai felhasználó jelszava"
                                classLabel="control-label"
                                classInput="form-control"
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                            <Field
                                type="text"
                                name="tax_number"
                                label="Felhasználó adószáma"
                                classLabel="control-label"
                                classInput="form-control"
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                                placeholder="Első 8 számjegy pl: 12345678"
                            />
                            <Field
                                type="text"
                                name="sign_key"
                                label="XML aláíró kulcs"
                                classLabel="control-label"
                                classInput="form-control"
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                            <Field
                                type="text"
                                name="exchange_key"
                                label="XML cserekulcs"
                                classLabel="control-label"
                                classInput="form-control"
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                            <div className="form-group  text-center">
                                <br/>
                                <button type="submit" onClick={() => this.submit()} className="btn green-btn" name="login-button">Mentés</button>
                            </div>
                        </div>
                        <div className='col-md-8'>
                            <h3 className='text-left'>NAV online adatkapcsolat - útmutató</h3>
                            <ul>
                                <li>A regisztrációt a <b>NAV Online Számla rendszerében</b> kell végrehajtani a <a href="https://onlineszamla.nav.gov.hu/regisztracio/start" target="_blank" rel="noopener noreferrer">https://onlineszamla.nav.gov.hu</a> oldalon.</li>
                                <li>Első alkalommal válaszd az <b>"Adatszolgáltatásra Kötelezett Adózói Regisztráció"</b> gombot. Jelentkezz be az ügyfélkapun! FONTOS: annak a felhasználónak (elsődleges felhasználónak) a hozzáférésével kell itt bejelentkezned, akihez az adott vállalkozás az ügyfélkapun is hozzá van rendelve!</li>
                                <li>Sikeres belépést követően add meg az <b>adóazonosító jeledet</b>. Kattints az ellenőrzésre, majd <b>válaszd ki a felhasználónevedet!</b></li>
                                <li>Válaszd ki a <b>regisztráció típusát</b> (gazdálkodó szervezet vagy egyéni vállalkozó), majd add meg az ahhoz tartozó részletes adataidat!</li>
                                <li>Sikeres regisztrációt követően <b>jelentkezz be</b> a megadott felhasználónévvel és jelszóval!</li>
                                <li>Amennyiben az adott felhasználónak több cég-felhasználó kapcsolata van, akkor a jobb felső sarokban található legördülő menüből elérhető <b>“Cég-felhasználó kapcsolatokra” kattintsunk</b>.</li>
                                <li>Ha az adott felhasználónak csak egy cég-felhasználó kapcsolata van, akkor az alkalmazás automatikusan továbblépteti a Cég-felhasználó kapcsolatok oldalra, ahol az adózó melletti <b>“megnyitás”</b> gombra kell kattintani.</li>
                                <li>A <b>“Felhasználók” menü</b> kiválasztása után az <b>“Új felhasználó” gombra kattintva</b>, hozz létre egy “Technikai felhasználót”.</li>
                                <li>Adj meg egy általad választott jelszót, illetve <b>jelöld be a “számlák kezelése” és a “számlák lekérdezése”</b> jelölőnégyzeteket, majd kattints a <b>“Mentés”</b> gombra.</li>
                                <li>A megjelenő oldalon kattints a <b>“kulcsgenerálás”</b> gombra. Ezzel létrehozod az XML aláíró és cserekulcsot.</li>
                                <li>Írd be a NAV rendszerben létrehozott <b>technikai felhasználó nevét</b>, <b>jelszavát</b>, az <b>XML aláíró kulcsot</b> és az <b>XML cserekulcsot</b> (4 adat) itt a számlázási fiókodban, a lenti mezőkbe. <b>FIGYELEM:</b> Ha véletlenül a NAV tesztrendszerében hajtottad végre a regisztrációt, a kapott adatokkal nem fog sikerülni az összekapcsolás, csak akkor, ha a <b>NAV éles rendszerében regisztráltál</b>!</li>
                            </ul>
                        </div>

                    </div>
                </section>
                <NotificationSystem ref='notificationSystem'/>
            </div>
        )
    }
}

export default Onlineszamla


// WEBPACK FOOTER //
// ./src/components/company/onlineszamla.js